<template>
  <div>
    <dx-popup
      :visible="loadingVisible"
      title="Generating gaji..."
      :drag-enabled="false"
      :hide-on-outside-click="false"
      width="300"
      :height="130"
    >
      <div class="d-flex justify-content-center">
        <div
          class="spinner-border"
          style="width: 3rem; height: 3rem"
          role="status"
        ></div>
      </div>
    </dx-popup>

    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#/final-gaji-list-draft">Daftar Gaji</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Generate Gaji
        </li>
      </ol>
    </nav>

    <h5 class="content-block">Generate Gaji</h5>

    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <p class="text-muted font-weight-light">Peraturan Penggajian</p>
        <div class="row">
          <!-- <div class="editors"> -->
          <div class="editors-container">
            <div class="col">
              <DxSelectBox
                :dataSource="bulanSource"
                valueExpr="id"
                displayExpr="name"
                width="100%"
                label="Periode Bulan"
                placeholder="Periode Bulan"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                v-model="filters.bulan"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>
            <div class="col" style="padding-left: 10px">
              <DxSelectBox
                :dataSource="tahunSource"
                width="100%"
                label="Periode Tahun"
                placeholder="Periode Tahun"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                v-model="filters.tahun"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>
            <div class="col" style="padding-left: 10px">
              <DxSelectBox
                :dataSource="pegawaiStatusSource"
                valueExpr="id"
                displayExpr="nama"
                width="100%"
                label="Pilih Pegawai"
                placeholder="Pegawai"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                @value-changed="onPegawaiChanged"
                v-model="filters.pegawai_status_id"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>
            <div class="col" style="padding-left: 10px">
              <DxSelectBox
                :dataSource="skemaGajiSource"
                valueExpr="id"
                displayExpr="nama"
                width="100%"
                label="Pilih Skema Penggajian"
                placeholder="Skema Penggajian"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                v-model="filters.gaji_skema_id"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>
            <div class="col" style="padding-left: 10px">
              <DxButton
                @click="validateFilter"
                text="Buat Gaji"
                styling-mode="filled"
                type="default"
                class="validate"
                style="float: left"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <div id="load">
          <!-- Note: Orderby error, filter OK
          <h6>find out why absen kaga masuk ke jml_tidak_hadir??</h6>
          <p>
            Note: [kontrak] generate OK, filter pegawai nama nik OK, filter
            riwayatPekerjaan/golongan OK, filter RP OK, order RP OK, order child
            X
          </p>
          <p>
            Note: [honor] generate OK, filter pegawai nama nik OK, filter
            riwayatPekerjaan/golongan OK, filter RP OK, order RP OK, order child
            X
          </p>
          <p>
            Note: [tetap] generate OK, filter pegawai nama nik OK, filter
            riwayatPekerjaan/golongan OK, filter RP OK, order RP OK, order child
            X
          </p>
          <p>
            Note: [direksi] tambah validasi bahwa gaji pegawai tetap harus
            generate dulu baru bisa generate direksi, filter gaji_skema_id pake
            or karena dirut, dirtek n dirum beda2 skemanya
          </p> -->
          <!-- <p>
            Note:
            <li>
              tambahin summary diakhir datagrid, summary untuk semua field kalo
              bisa,
            </li>
            <li>
              tambahin error kenapa ga bisa generate gaji ex: ga ada absen, gaji
              sudah digenerate, atau pegawai tetap blm generate if want to
              generate direksi
            </li>
          </p> -->

          <!-- <DxLoadPanel
            :position="position"
            v-model:visible="loadingVisible"
            :show-indicator="showIndicator"
            :show-pane="showPane"
            :shading="shading"
            :hide-on-outside-click="hideOnOutsideClick"
            :on-shown="onShown"
            :on-hidden="onHidden"
            shading-color="rgba(0,0,0,0.4)"
          /> -->

          <DxDataGrid
            v-if="gridShowHonor"
            ref="gridRefHonor"
            id="gridHonor"
            :data-source="dataSource"
            :allow-column-reordering="true"
            :show-borders="true"
            key-expr="id"
            @editor-preparing="oneditorpreparing"
            :show-column-lines="false"
            :column-auto-width="true"
            :column-hiding-enabled="false"
            @option-changed="onPageChanged($event, 'gridRefHonor')"
            @load="onDataGridLoad"
            @exporting="onExporting"
            :focused-row-enabled="true"
            :focused-row-index="0"
            @row-updating="onRowUpdating($event, 'gridRefHonor')"
            :remote-operations="true"
            :word-wrap-enabled="true"
            :height="gridHeight"
            :scrolling="{ mode: 'virtual' }"
          >
            <DxScrolling mode="virtual" row-rendering-mode="virtual" />
            <DxFilterRow :visible="true" />
            <dx-pager :show-page-size-selector="true" :show-info="true" />
            <DxPaging :enabled="true" :page-size="numberingPageSize" />
            <DxExport :enabled="true" :allow-export-selected-data="true" />
            <DxEditing
              :allow-updating="true"
              :allow-deleting="false"
              :allow-adding="false"
              mode="row"
            />

            <DxToolbar>
              <DxItem location="after" template="refresh-template" />
              <DxItem name="exportButton" />
              <DxItem name="columnChooserButton" />
            </DxToolbar>
            <template #refresh-template>
              <DxButton
                icon="refresh"
                @click="refreshDatagrid('gridRefHonor')"
                text="Refresh Data"
                type="default"
                style="float: left"
                width="160px"
                styling-mode="outlined"
              ></DxButton>
            </template>

            <DxSelection mode="multiple" />
            <DxColumnFixing :enabled="true" />
            <DxColumn
              type="buttons"
              :fixed="true"
              fixed-position="right"
              :allow-hiding="false"
            >
              <DxButtonDatagrid name="edit" />
              <DxButtonDatagrid
                hint="Detail Pegawai"
                icon="search"
                :visible="true"
                @click="detailPegawai"
              />
            </DxColumn>
            <DxColumn
              class="noteditable"
              data-field="status_gaji"
              caption="Status Gaji"
              cell-template="statusTemplate"
              :fixed="true"
              fixed-position="left"
              :allow-hiding="false"
            />
            <template #statusTemplate="{ data }">
              <!-- {{ formatStatusGaji(data.text) }} -->
              <DxButton
                :icon="formatStatusGaji('icon', { data })"
                :type="formatStatusGaji('type', { data })"
                @click="approveClick({ data })"
              />
            </template>
            <!-- <DxColumn
              class="noteditable"
              caption="#"
              data-field="created_at"
              cell-template="numberingTemplate"
              :allow-filtering="false"
              :allow-sorting="false"
              :fixed="true"
              fixed-position="left"
              :allow-hiding="false"
            />

            <template #numberingTemplate="{ data }">
              {{ numberingPageNumber * numberingPageSize + data.rowIndex + 1 }}
            </template> -->
            <template #currencyTemplate="{ data }">
              {{ formatNumber(data.value) }}
            </template>

            <DxColumn
              class="noteditable"
              data-field="pegawai.nik"
              caption="NIK"
              :fixed="true"
              fixed-position="left"
              :allow-hiding="false"
            />

            <DxColumn
              class="noteditable"
              data-field="pegawai.nama"
              caption="Nama pegawai"
              :fixed="true"
              fixed-position="left"
              :allow-hiding="false"
            />

            <DxColumn
              class="noteditable"
              data-field="golongan_id"
              caption="Gol."
              :allow-hiding="false"
            >
              <DxLookup
                :data-source="golonganSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>
            <DxColumn
              class="noteditable"
              data-field="riwayaPekerjaan.jabatan_id"
              caption="Jabatan"
              :allow-hiding="false"
            >
              <DxLookup
                :data-source="jabatanSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>
            <DxColumn
              class="noteditable"
              data-field="riwayatPekerjaan.cabang_id"
              caption="Cabang"
              :allow-hiding="false"
            >
              <DxLookup
                :data-source="cabangSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>
            <DxColumn
              class="noteditable"
              data-field="riwayatPekerjaan.unit_id"
              caption="Unit"
              :allow-hiding="false"
            >
              <DxLookup
                :data-source="unitSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>
            <DxColumn
              class="noteditable"
              data-field="riwayatPekerjaan.bagian_id"
              caption="Bagian"
              :allow-hiding="false"
            >
              <DxLookup
                :data-source="bagianSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>
            <DxColumn
              class="noteditable"
              data-field="riwayatPekerjaan.sub_bagian_id"
              caption="Sub Bagian"
              :allow-hiding="false"
            >
              <DxLookup
                :data-source="subBagianSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>
            <DxColumn
              class="noteditable"
              data-field="riwayatPekerjaan.bidang_id"
              caption="Bidang"
              :allow-hiding="false"
            >
              <DxLookup
                :data-source="bidangSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>

            <DxColumn
              class="noteditable"
              data-field="riwayatPekerjaan.sub_bidang_id"
              caption="Sub Bidang"
              :allow-hiding="false"
            >
              <DxLookup
                :data-source="subBidangSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>
            <DxColumn
              class="noteditable"
              data-field="riwayatPekerjaan.seksi_id"
              caption="Seksi"
              :allow-hiding="false"
            >
              <DxLookup
                :data-source="seksiSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>

            <DxColumn
              class="noteditable"
              data-field="pegawai.tgl_mulai_bekerja"
              caption="TMT Kontrak"
              data-type="date"
              :display-format="'dd/MM/yyyy'"
              :format="'dd/MM/yyyy'"
              :allow-hiding="false"
            />
            <!-- <DxColumn
              class="noteditable"
              data-field="riwayatPekerjaan"
              caption="Masa Kerja"
              :calculate-display-value="calculateDisplayMK"
              :allow-hiding="false"
            /> -->
            <DxColumn
              class="noteditable"
              data-field="pegawai.tgl_mulai_bekerja"
              caption="Masa Kerja"
              :calculate-cell-value="calculateCellMK"
              data-type="string"
            ></DxColumn>

            <DxColumn
              data-field="honor_umk_jml"
              caption="Honor (UMK)"
              cell-template="currencyTemplate"
              :allow-hiding="false"
            />

            <DxColumn
              data-field="kenaikan_masa_kerja"
              caption="Kenaikan Masa Kerja"
              cell-template="currencyTemplate"
              :allow-hiding="false"
            />
            <DxColumn
              data-field="tun_kesehatan"
              caption="Tunj. Kesehatan"
              cell-template="currencyTemplate"
              :allow-hiding="false"
            />
            <DxColumn
              data-field="absenBulan.tidak_hadir"
              caption="Jml Tidak Hadir"
              :allow-hiding="false"
            />
            <!-- <DxColumn data-field="jml_tdk_hadir" caption="Jml Tidak Hadir" /> -->
            <DxColumn
              class="noteditable"
              data-field="pot_5_persen"
              caption="Pot. Tdk Hadir"
              cell-template="currencyTemplate"
              :allow-hiding="false"
            />

            <DxColumn
              class="noteditable"
              data-field="jml_bruto"
              caption="Jml Bruto"
              cell-template="currencyTemplate"
              :allow-hiding="false"
            />
            <DxColumn
              class="noteditable"
              data-field="pot_kesehatan"
              caption="Pot. Kesehatan"
              cell-template="currencyTemplate"
              :allow-hiding="false"
            />
            <DxColumn
              class="noteditable"
              data-field="pot_bpjs_tk_dua_persen"
              caption="Pot. BPJS TK 2%"
              cell-template="currencyTemplate"
              :allow-hiding="false"
            />
            <DxColumn
              class="noteditable"
              data-field="total_diterima"
              caption="Total Diterima"
              cell-template="currencyTemplate"
              :allow-hiding="false"
            />
            <DxColumn
              class="noteditable"
              data-field="edited_by_user"
              caption="Ket."
              :allow-hiding="false"
            >
              <DxLookup
                :data-source="editedSource"
                value-expr="val"
                display-expr="nama"
            /></DxColumn>
            <DxSummary>
              <DxTotalItem
                column="created_at"
                summary-type="count"
                value-format="#,##0"
              />
              <DxTotalItem
                column="honor_umk_jml"
                summary-type="sum"
                value-format="#,##0"
              />
              <DxTotalItem
                column="kenaikan_masa_kerja"
                summary-type="sum"
                value-format="#,##0"
              />
              <DxTotalItem
                column="tun_kesehatan"
                summary-type="sum"
                value-format="#,##0"
              />
              <DxTotalItem
                column="absenBulan.tidak_hadir"
                summary-type="sum"
                value-format="#,##0"
              />

              <!-- <DxTotalItem
                column="jml_tdk_hadir"
                summary-type="sum"
                value-format="#,##0"
              /> -->
              <DxTotalItem
                column="pot_5_persen"
                summary-type="sum"
                value-format="#,##0"
              />
              <DxTotalItem
                column="jml_bruto"
                summary-type="sum"
                value-format="#,##0"
              />
              <DxTotalItem
                column="pot_kesehatan"
                summary-type="sum"
                value-format="#,##0"
              />
              <DxTotalItem
                column="pot_bpjs_tk_dua_persen"
                summary-type="sum"
                value-format="#,##0"
              />
              <DxTotalItem
                column="total_diterima"
                summary-type="sum"
                value-format="#,##0"
              />
            </DxSummary>
            <DxColumnChooser :enabled="true" :mode="mode">
              <DxPosition
                my="right top"
                at="right bottom"
                of=".dx-datagrid-column-chooser-button"
              />

              <DxColumnChooserSearch
                :enabled="true"
                :editor-options="editorOptions"
              />
              <DxColumnChooserSelection
                :allow-select-all="allowSelectAll"
                :select-by-click="selectByClick"
                :recursive="recursive"
              />
            </DxColumnChooser>
          </DxDataGrid>
          <DxButton
            v-if="gridShowHonor"
            @click="approveAllDialog"
            text="approve semua"
            type="danger"
            class="validate"
          />

          <DxDataGrid
            v-if="gridShowKontrak"
            ref="gridRefKontrak"
            id="gridKontrak"
            :data-source="dataSource"
            :allow-column-reordering="true"
            :show-borders="true"
            key-expr="id"
            @editor-preparing="oneditorpreparing"
            :show-column-lines="false"
            :column-auto-width="true"
            :column-hiding-enabled="false"
            @option-changed="onPageChanged($event, 'gridRefKontrak')"
            @load="onDataGridLoad"
            @exporting="onExporting"
            :focused-row-enabled="true"
            :focused-row-index="0"
            @row-updating="onRowUpdating($event, 'gridRefKontrak')"
            :remote-operations="true"
            :word-wrap-enabled="true"
            :height="gridHeight"
            :scrolling="{ mode: 'virtual' }"
          >
            <DxScrolling mode="virtual" row-rendering-mode="virtual" />
            <DxFilterRow :visible="true" />
            <dx-pager :show-page-size-selector="true" :show-info="true" />
            <DxPaging :enabled="true" :page-size="numberingPageSize" />
            <DxExport :enabled="true" :allow-export-selected-data="true" />
            <DxEditing
              :allow-updating="true"
              :allow-deleting="false"
              :allow-adding="false"
              mode="row"
            />
            <DxToolbar>
              <DxItem location="after" template="refresh-template" />
              <DxItem name="exportButton" />
              <DxItem name="columnChooserButton" />
            </DxToolbar>
            <template #refresh-template>
              <DxButton
                icon="refresh"
                @click="refreshDatagrid('gridRefKontrak')"
                text="Refresh Data"
                type="default"
                style="float: left"
                width="160px"
                styling-mode="outlined"
              ></DxButton>
            </template>

            <DxSelection mode="multiple" />
            <DxColumnFixing :enabled="true" />
            <DxColumn type="buttons" :fixed="true" fixed-position="right">
              <DxButtonDatagrid name="edit" />
              <DxButtonDatagrid
                hint="Detail Pegawai"
                icon="search"
                :visible="true"
                @click="detailPegawai"
                :allow-hiding="false"
              />
            </DxColumn>
            <DxColumn
              class="noteditable"
              data-field="status_gaji"
              caption="Status Gaji"
              cell-template="statusTemplate"
              :fixed="true"
              fixed-position="left"
              :allow-hiding="false"
            />
            <template #statusTemplate="{ data }">
              <!-- {{ formatStatusGaji(data.text) }} -->
              <DxButton
                :icon="formatStatusGaji('icon', { data })"
                :type="formatStatusGaji('type', { data })"
                @click="approveClick({ data })"
              />
            </template>
            <!-- <DxColumn
              class="noteditable"
              caption="#"
              data-field="created_at"
              cell-template="numberingTemplate"
              :allow-filtering="false"
              :allow-sorting="false"
              :fixed="true"
              fixed-position="left"
              :allow-hiding="false"
            />

            <template #numberingTemplate="{ data }">
              {{ numberingPageNumber * numberingPageSize + data.rowIndex + 1 }}
            </template> -->
            <template #currencyTemplate="{ data }">
              {{ formatNumber(data.value) }}
            </template>

            <DxColumn
              class="noteditable"
              data-field="pegawai.nik"
              caption="NIK"
              :fixed="true"
              fixed-position="left"
              :allow-hiding="false"
            />

            <DxColumn
              class="noteditable"
              data-field="pegawai.nama"
              caption="Nama pegawai"
              :fixed="true"
              fixed-position="left"
              :allow-hiding="false"
            />

            <DxColumn
              class="noteditable"
              data-field="golongan_id"
              caption="Gol."
              :allow-hiding="false"
            >
              <DxLookup
                :data-source="golonganSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>
            <DxColumn
              class="noteditable"
              data-field="riwayatPekerjaan.jabatan_id"
              caption="Jabatan"
              :allow-hiding="false"
            >
              <DxLookup
                :data-source="jabatanSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>

            <DxColumn
              class="noteditable"
              data-field="riwayatPekerjaan.cabang_id"
              caption="Cabang"
              :allow-hiding="false"
            >
              <DxLookup
                :data-source="cabangSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>
            <DxColumn
              class="noteditable"
              data-field="riwayatPekerjaan.unit_id"
              caption="Unit"
              :allow-hiding="false"
            >
              <DxLookup
                :data-source="unitSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>

            <DxColumn
              class="noteditable"
              data-field="riwayatPekerjaan.bagian_id"
              caption="Bagian"
              :allow-hiding="false"
            >
              <DxLookup
                :data-source="bagianSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>
            <DxColumn
              class="noteditable"
              data-field="riwayatPekerjaan.sub_bagian_id"
              caption="Sub Bagian"
              :allow-hiding="false"
            >
              <DxLookup
                :data-source="subBagianSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>
            <DxColumn
              class="noteditable"
              data-field="riwayatPekerjaan.bidang_id"
              caption="Bidang"
              :allow-hiding="false"
            >
              <DxLookup
                :data-source="bidangSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>

            <DxColumn
              class="noteditable"
              data-field="riwayatPekerjaan.sub_bidang_id"
              caption="Sub Bidang"
              :allow-hiding="false"
            >
              <DxLookup
                :data-source="subBidangSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>
            <DxColumn
              class="noteditable"
              data-field="riwayatPekerjaan.seksi_id"
              caption="Seksi"
              :allow-hiding="false"
            >
              <DxLookup
                :data-source="seksiSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>

            <DxColumn
              class="noteditable"
              data-field="pegawai.tgl_mulai_bekerja"
              caption="TMT Kontrak"
              data-type="date"
              :display-format="'dd/MM/yyyy'"
              :format="'dd/MM/yyyy'"
              :allow-hiding="false"
            />
            <DxColumn
              class="noteditable"
              data-field="pegawai.tgl_mulai_bekerja"
              caption="Masa Kerja"
              :calculate-cell-value="calculateCellMK"
              data-type="string"
            ></DxColumn>

            <!-- <DxColumn
              class="noteditable"
              data-field="riwayatPekerjaan"
              caption="Masa Kerja"
              :calculate-display-value="calculateDisplayMK"
              :allow-hiding="false"
            /> -->
            <DxColumn
              data-field="honor_umk_jml"
              caption="Honor (UMK)"
              cell-template="currencyTemplate"
              :allow-hiding="false"
            />
            <DxColumn
              data-field="kenaikan_masa_kerja"
              caption="Kenaikan Masa Kerja"
              cell-template="currencyTemplate"
              :allow-hiding="false"
            />
            <DxColumn
              data-field="tun_kesehatan"
              caption="Tunj. Kesehatan"
              cell-template="currencyTemplate"
              :allow-hiding="false"
            />
            <DxColumn
              data-field="absenBulan.tidak_hadir"
              caption="Jml Tdk Hadir"
              :allow-hiding="false"
            />
            <!-- <DxColumn data-field="jml_tdk_hadir" caption="Jml Tidak Hadir" /> -->
            <DxColumn
              class="noteditable"
              data-field="pot_5_persen"
              caption="Pot. Tdk Hadir"
              cell-template="currencyTemplate"
              :allow-hiding="false"
            />
            <DxColumn
              class="noteditable"
              data-field="tun_bpjs_tk_satu_sembilanbelas_persen"
              caption="Tunj. BPJS TK 1.19%"
              cell-template="currencyTemplate"
              :allow-hiding="false"
            />
            <DxColumn
              class="noteditable"
              data-field="jml_bruto"
              caption="Jml Bruto"
              cell-template="currencyTemplate"
              :allow-hiding="false"
            />
            <DxColumn
              class="noteditable"
              data-field="pot_kesehatan"
              caption="Pot. Kesehatan"
              cell-template="currencyTemplate"
              :allow-hiding="false"
            />
            <DxColumn
              class="noteditable"
              data-field="pot_bpjs_tk_satu_sembilanbelas_persen"
              caption="Pot. BPJS TK 1.19%"
              cell-template="currencyTemplate"
              :allow-hiding="false"
            />
            <DxColumn
              class="noteditable"
              data-field="total_diterima"
              caption="Total Diterima"
              cell-template="currencyTemplate"
              :allow-hiding="false"
            />
            <DxColumn
              class="noteditable"
              data-field="edited_by_user"
              caption="Ket."
              :allow-hiding="false"
            >
              <DxLookup
                :data-source="editedSource"
                value-expr="val"
                display-expr="nama"
            /></DxColumn>
            <DxSummary>
              <DxTotalItem
                column="created_at"
                summary-type="count"
                value-format="#,##0"
              />
              <DxTotalItem
                column="honor_umk_jml"
                summary-type="sum"
                value-format="#,##0"
              />
              <DxTotalItem
                column="kenaikan_masa_kerja"
                summary-type="sum"
                value-format="#,##0"
              />
              <DxTotalItem
                column="tun_kesehatan"
                summary-type="sum"
                value-format="#,##0"
              />
              <DxTotalItem
                column="absenBulan.tidak_hadir"
                summary-type="sum"
                value-format="#,##0"
              />

              <!-- <DxTotalItem
                column="jml_tdk_hadir"
                summary-type="sum"
                value-format="#,##0"
              /> -->
              <DxTotalItem
                column="pot_5_persen"
                summary-type="sum"
                value-format="#,##0"
              />
              <DxTotalItem
                column="tun_bpjs_tk_satu_sembilanbelas_persen"
                summary-type="sum"
                value-format="#,##0"
              />
              <DxTotalItem
                column="jml_bruto"
                summary-type="sum"
                value-format="#,##0"
              />
              <DxTotalItem
                column="pot_kesehatan"
                summary-type="sum"
                value-format="#,##0"
              />
              <DxTotalItem
                column="pot_bpjs_tk_satu_sembilanbelas_persen"
                summary-type="sum"
                value-format="#,##0"
              />
              <DxTotalItem
                column="total_diterima"
                summary-type="sum"
                value-format="#,##0"
              />
            </DxSummary>
            <DxColumnChooser :enabled="true" :mode="mode">
              <DxPosition
                my="right top"
                at="right bottom"
                of=".dx-datagrid-column-chooser-button"
              />

              <DxColumnChooserSearch
                :enabled="true"
                :editor-options="editorOptions"
              />
              <DxColumnChooserSelection
                :allow-select-all="allowSelectAll"
                :select-by-click="selectByClick"
                :recursive="recursive"
              />
            </DxColumnChooser>
          </DxDataGrid>
          <DxButton
            v-if="gridShowKontrak"
            @click="approveAllDialog"
            text="approve semua"
            type="danger"
            class="validate"
          />

          <DxDataGrid
            v-if="gridShowTetap"
            ref="gridRefTetap"
            id="gridTetap"
            :data-source="dataSource"
            :allow-column-reordering="true"
            :show-borders="true"
            key-expr="id"
            @editor-preparing="oneditorpreparing"
            :show-column-lines="false"
            :column-auto-width="true"
            :column-hiding-enabled="false"
            @option-changed="onPageChanged($event, 'gridRefTetap')"
            @load="onDataGridLoad"
            @exporting="onExporting"
            :focused-row-enabled="true"
            :focused-row-index="0"
            @row-updating="onRowUpdating($event, 'gridRefTetap')"
            :remote-operations="true"
            :word-wrap-enabled="true"
            :height="gridHeight"
            :scrolling="{ mode: 'virtual' }"
          >
            <DxScrolling mode="virtual" row-rendering-mode="virtual" />
            <DxFilterRow :visible="true" />
            <dx-pager :show-page-size-selector="true" :show-info="true" />
            <DxPaging :enabled="true" :page-size="numberingPageSize" />
            <DxExport :enabled="true" :allow-export-selected-data="true" />
            <DxEditing
              :allow-updating="true"
              :allow-deleting="false"
              :allow-adding="false"
              mode="row"
            />
            <DxToolbar>
              <DxItem location="after" template="refresh-template" />
              <DxItem name="exportButton" />
              <DxItem name="columnChooserButton" />
            </DxToolbar>
            <template #refresh-template>
              <DxButton
                icon="refresh"
                @click="refreshDatagrid('gridRefTetap')"
                text="Refresh Data"
                type="default"
                style="float: left"
                width="160px"
                styling-mode="outlined"
              ></DxButton>
            </template>

            <DxSelection mode="multiple" />
            <DxColumnFixing :enabled="true" />
            <DxColumn
              type="buttons"
              :fixed="true"
              fixed-position="right"
              :allow-hiding="false"
            >
              <DxButtonDatagrid name="edit" />
              <DxButtonDatagrid
                hint="Detail Pegawai"
                icon="search"
                :visible="true"
                @click="detailPegawai"
              />
            </DxColumn>
            <DxColumn
              class="noteditable"
              data-field="status_gaji"
              caption="Status Gaji"
              cell-template="statusTemplate"
              :fixed="true"
              fixed-position="left"
              :allow-hiding="false"
            />
            <template #statusTemplate="{ data }">
              <!-- {{ formatStatusGaji(data.text) }} -->
              <DxButton
                :icon="formatStatusGaji('icon', { data })"
                :type="formatStatusGaji('type', { data })"
                @click="approveClick({ data })"
              />
            </template>
            <!-- <DxColumn
              class="noteditable"
              caption="#"
              data-field="created_at"
              cell-template="numberingTemplate"
              :allow-filtering="false"
              :allow-sorting="false"
              :fixed="true"
              fixed-position="left"
              :allow-hiding="false"
            />

            <template #numberingTemplate="{ data }">
              {{ numberingPageNumber * numberingPageSize + data.rowIndex + 1 }}
            </template> -->
            <template #currencyTemplate="{ data }">
              {{ formatNumber(data.value) }}
            </template>
            <DxColumn
              class="noteditable"
              data-field="pegawai.nik"
              caption="NIK"
              :fixed="true"
              fixed-position="left"
              :allow-hiding="false"
            />

            <DxColumn
              class="noteditable"
              data-field="pegawai.nama"
              caption="Nama pegawai"
              :fixed="true"
              fixed-position="left"
              :allow-hiding="false"
            />
            <DxColumn
              class="noteditable"
              data-field="golongan_id"
              caption="Gol."
              :allow-hiding="false"
            >
              <DxLookup
                :data-source="golonganSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>
            <DxColumn
              class="noteditable"
              data-field="pegawai.status_ptkp"
              caption="Status PTKP"
              :allow-hiding="false"
            />
            <DxColumn
              data-field="riwayatPekerjaan.jabatan_id"
              caption="Jabatan"
              :allow-hiding="false"
            >
              <DxLookup
                :data-source="jabatanSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>
            <DxColumn
              class="noteditable"
              data-field="riwayatPekerjaan.cabang_id"
              caption="Cabang"
              :allow-hiding="false"
            >
              <DxLookup
                :data-source="cabangSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>
            <DxColumn
              class="noteditable"
              data-field="riwayatPekerjaan.unit_id"
              caption="Unit"
              :allow-hiding="false"
            >
              <DxLookup
                :data-source="unitSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>

            <DxColumn
              class="noteditable"
              data-field="riwayatPekerjaan.bagian_id"
              caption="Bagian"
              :allow-hiding="false"
            >
              <DxLookup
                :data-source="bagianSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>
            <DxColumn
              class="noteditable"
              data-field="riwayatPekerjaan.sub_bagian_id"
              caption="Sub Bagian"
              :allow-hiding="false"
            >
              <DxLookup
                :data-source="subBagianSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>
            <DxColumn
              class="noteditable"
              data-field="riwayatPekerjaan.bidang_id"
              caption="Bidang"
              :allow-hiding="false"
            >
              <DxLookup
                :data-source="bidangSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>

            <DxColumn
              class="noteditable"
              data-field="riwayatPekerjaan.sub_bidang_id"
              caption="Sub Bidang"
              :allow-hiding="false"
            >
              <DxLookup
                :data-source="subBidangSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>
            <DxColumn
              class="noteditable"
              data-field="riwayatPekerjaan.seksi_id"
              caption="Seksi"
              :allow-hiding="false"
            >
              <DxLookup
                :data-source="seksiSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>

            <DxColumn caption="Jabatan PLT">
              <DxColumn
                data-field="riwayatPlt.jabatan_id"
                caption="Jabatan PLT"
              >
                <DxLookup
                  :data-source="jabatanSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn data-field="riwayatPlt.cabang_id" caption="Cabang PLT">
                <DxLookup
                  :data-source="cabangSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn data-field="riwayatPlt.unit_id" caption="Unit PLT">
                <DxLookup
                  :data-source="unitSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>

              <DxColumn data-field="riwayatPlt.bagian_id" caption="Bagian PLT">
                <DxLookup
                  :data-source="bagianSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-field="riwayatPlt.sub_bagian_id"
                caption="Sub Bagian PLT"
              >
                <DxLookup
                  :data-source="subBagianSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn data-field="riwayatPlt.bidang_id" caption="Bidang PLT">
                <DxLookup
                  :data-source="bidangSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-field="riwayatPlt.sub_bidang_id"
                caption="Sub Bidang PLT"
              >
                <DxLookup
                  :data-source="subBidangSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
            </DxColumn>

            <!-- <DxColumn
              class="noteditable"
              data-field="riwayatPekerjaan"
              caption="Masa Kerja"
              :calculate-display-value="calculateDisplayMK"
              :allow-hiding="false"
            /> -->
            <DxColumn
              data-field="gaji_pokok"
              caption="Gaji Pokok"
              cell-template="currencyTemplate"
              :allow-hiding="false"
            />
            <DxColumn
              data-field="tun_perusahaan"
              caption="Tunj. Perusahaan"
              cell-template="currencyTemplate"
              :allow-hiding="false"
            />
            <DxColumn
              data-field="tun_jabatan"
              caption="Tunj. Jabatan"
              cell-template="currencyTemplate"
              :allow-hiding="false"
            />
            <DxColumn
              data-field="tun_kemahalan"
              caption="Tunj. Kemahalan"
              cell-template="currencyTemplate"
              :allow-hiding="false"
            />
            <DxColumn
              data-field="tun_air"
              caption="Tunj. Air"
              cell-template="currencyTemplate"
              :allow-hiding="false"
            />
            <DxColumn
              data-field="tun_transport"
              caption="Tunj. Transport"
              cell-template="currencyTemplate"
              :allow-hiding="false"
            />
            <DxColumn
              data-field="tun_pangan"
              caption="Tunj. Pangan"
              cell-template="currencyTemplate"
              :allow-hiding="false"
            />
            <DxColumn
              data-field="tun_kesehatan"
              caption="Tunj. Kesehatan"
              cell-template="currencyTemplate"
              :allow-hiding="false"
            />
            <DxColumn
              data-field="absenBulan.tidak_hadir"
              caption="Jml Tdk Hadir"
              :allow-hiding="false"
            />
            <!-- <DxColumn data-field="jml_tdk_hadir" caption="Jml Tidak Hadir" /> -->
            <DxColumn
              class="noteditable"
              data-field="pot_5_persen"
              caption="Pot. Tdk Hadir"
              cell-template="currencyTemplate"
              :allow-hiding="false"
            />
            <DxColumn
              class="noteditable"
              data-field="jml_bruto"
              caption="Jml Bruto"
              cell-template="currencyTemplate"
              :allow-hiding="false"
            />
            <DxColumn
              class="noteditable"
              data-field="tun_pph"
              caption="Tunj. PPH"
              cell-template="currencyTemplate"
              :allow-hiding="false"
            />
            <DxColumn
              class="noteditable"
              data-field="pot_kesehatan"
              caption="Pot. Kesehatan"
              cell-template="currencyTemplate"
              :allow-hiding="false"
            />
            <DxColumn
              class="noteditable"
              data-field="pot_bpjs_tk_tiga_program"
              caption="Pot. BPJS TK 3 Program"
              cell-template="currencyTemplate"
              :allow-hiding="false"
            />
            <DxColumn
              class="noteditable"
              data-field="pot_bpjs_tk_empat_program"
              caption="Pot. BPJS TK 4 Program"
              cell-template="currencyTemplate"
              :allow-hiding="false"
            />
            <DxColumn
              class="noteditable"
              data-field="pot_pensiun"
              caption="Pot. Pensiun Jiwasraya"
              cell-template="currencyTemplate"
              :allow-hiding="false"
            />
            <DxColumn
              class="noteditable"
              data-field="pot_pph"
              caption="Pot. PPH"
              cell-template="currencyTemplate"
              :allow-hiding="false"
            />
            <DxColumn
              class="noteditable"
              data-field="total_diterima"
              caption="Total Diterima"
              cell-template="currencyTemplate"
              :allow-hiding="false"
            />
            <DxColumn
              class="noteditable"
              data-field="edited_by_user"
              caption="Ket."
              :allow-hiding="false"
            >
              <DxLookup
                :data-source="editedSource"
                value-expr="val"
                display-expr="nama"
            /></DxColumn>
            <DxSummary>
              <DxTotalItem
                column="created_at"
                summary-type="count"
                value-format="#,##0"
              />
              <DxTotalItem
                column="gaji_pokok"
                summary-type="sum"
                value-format="#,##0"
              />
              <DxTotalItem
                column="tun_perusahaan"
                summary-type="sum"
                value-format="#,##0"
              />

              <DxTotalItem
                column="tun_jabatan"
                summary-type="sum"
                value-format="#,##0"
              />
              <DxTotalItem
                column="tun_kemahalan"
                summary-type="sum"
                value-format="#,##0"
              />
              <DxTotalItem
                column="tun_air"
                summary-type="sum"
                value-format="#,##0"
              />
              <DxTotalItem
                column="tun_transport"
                summary-type="sum"
                value-format="#,##0"
              />
              <DxTotalItem
                column="tun_pangan"
                summary-type="sum"
                value-format="#,##0"
              />
              <DxTotalItem
                column="tun_kesehatan"
                summary-type="sum"
                value-format="#,##0"
              />
              <DxTotalItem
                column="absenBulan.tidak_hadir"
                summary-type="sum"
                value-format="#,##0"
              />

              <!-- <DxTotalItem
                column="jml_tdk_hadir"
                summary-type="sum"
                value-format="#,##0"
              /> -->
              <DxTotalItem
                column="pot_5_persen"
                summary-type="sum"
                value-format="#,##0"
              />
              <DxTotalItem
                column="jml_bruto"
                summary-type="sum"
                value-format="#,##0"
              />
              <DxTotalItem
                column="tun_pph"
                summary-type="sum"
                value-format="#,##0"
              />

              <DxTotalItem
                column="pot_kesehatan"
                summary-type="sum"
                value-format="#,##0"
              />
              <DxTotalItem
                column="pot_bpjs_tk_tiga_program"
                summary-type="sum"
                value-format="#,##0"
              />
              <DxTotalItem
                column="pot_bpjs_tk_empat_program"
                summary-type="sum"
                value-format="#,##0"
              />
              <DxTotalItem
                column="pot_pensiun"
                summary-type="sum"
                value-format="#,##0"
              />
              <DxTotalItem
                column="pot_pph"
                summary-type="sum"
                value-format="#,##0"
              />
              <DxTotalItem
                column="total_diterima"
                summary-type="sum"
                value-format="#,##0"
              />
            </DxSummary>
            <DxColumnChooser :enabled="true" :mode="mode">
              <DxPosition
                my="right top"
                at="right bottom"
                of=".dx-datagrid-column-chooser-button"
              />

              <DxColumnChooserSearch
                :enabled="true"
                :editor-options="editorOptions"
              />
              <DxColumnChooserSelection
                :allow-select-all="allowSelectAll"
                :select-by-click="selectByClick"
                :recursive="recursive"
              />
            </DxColumnChooser>
          </DxDataGrid>
          <DxButton
            v-if="gridShowTetap"
            @click="approveAllDialog"
            text="approve semua"
            type="danger"
            class="validate"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
<script>
import axios from "axios";
import api from "@/api";
import { API_BASE_URL } from "@/global-constants";
import { ODATA_BASE_URL } from "@/global-constants";
import notify from "devextreme/ui/notify";
import { DxValidator, DxRequiredRule } from "devextreme-vue/validator";
import DxButton from "devextreme-vue/button";
import DxSelectBox from "devextreme-vue/select-box";
import ODataStore from "devextreme/data/odata/store";
import { DateTime } from "luxon";
import DataSource from "devextreme/data/data_source";
import _ from "lodash";
import { DxPopup } from "devextreme-vue/popup";
// import { DxLoadPanel } from "devextreme-vue/load-panel";
// import DxDropDownButton from "devextreme-vue/drop-down-button";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxToolbar,
  DxSummary,
  DxTotalItem,
  DxButton as DxButtonDatagrid,
  DxColumnChooser,
  DxColumnChooserSearch,
  DxColumnChooserSelection,
  DxPosition,
  DxScrolling,
} from "devextreme-vue/data-grid";
// import { toHandlerKey } from "vue";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import { confirm } from "devextreme/ui/dialog";

import { useGolonganStore } from "@/stores/GolonganStore";
import { useJabatanStore } from "@/stores/JabatanStore";
import { useBagianStore } from "@/stores/BagianStore";
import { useBidangStore } from "@/stores/BidangStore";
import { useSubBagianStore } from "@/stores/SubBagianStore";
import { useSubBidangStore } from "@/stores/SubBidangStore";
import { useSeksiStore } from "@/stores/SeksiStore";
import { useCabangStore } from "@/stores/CabangStore";
import { useUnitStore } from "@/stores/UnitStore";
import { usePegawaiStatusStore } from "@/stores/PegawaiStatusStore";

const months = [
  { name: "Januari", id: 1 },
  { name: "Februari", id: 2 },
  { name: "Maret", id: 3 },
  { name: "April", id: 4 },
  { name: "Mei", id: 5 },
  { name: "Juni", id: 6 },
  { name: "Juli", id: 7 },
  { name: "Agustus", id: 8 },
  { name: "September", id: 9 },
  { name: "Oktober", id: 10 },
  { name: "November", id: 11 },
  { name: "Desember", id: 12 },
];

const currentYear = DateTime.now().toFormat("yyyy");
const currentMonth = DateTime.now().toFormat("M");
const years = [Number(currentYear) - 1, currentYear, Number(currentYear) + 1];

export default {
  components: {
    DxSelectBox,
    DxButton,
    DxValidator,
    DxRequiredRule,
    DxDataGrid,
    // eslint-disable-next-line
    DxColumn,
    DxPager,
    DxPaging,
    DxEditing,
    DxFilterRow,
    // eslint-disable-next-line
    DxLookup,
    DxColumnFixing,
    DxSelection,
    DxExport,
    DxToolbar,
    // DxLoadPanel,
    // DxDropDownButton,
    DxSummary,
    DxTotalItem,
    DxButtonDatagrid,
    DxColumnChooser,
    DxColumnChooserSearch,
    DxColumnChooserSelection,
    DxPosition,
    DxPopup,
    DxScrolling,
  },
  setup() {
    const golonganStore = useGolonganStore();
    const jabatanStore = useJabatanStore();
    const bagianStore = useBagianStore();
    const bidangStore = useBidangStore();
    const subBagianStore = useSubBagianStore();
    const subBidangStore = useSubBidangStore();
    const seksiStore = useSeksiStore();
    const cabangStore = useCabangStore();
    const unitStore = useUnitStore();
    const pegawaiStatusStore = usePegawaiStatusStore();

    return {
      golonganStore,
      jabatanStore,
      bagianStore,
      bidangStore,
      subBagianStore,
      subBidangStore,
      seksiStore,
      cabangStore,
      unitStore,
      pegawaiStatusStore,
    };
  },

  data() {
    return {
      mode: "select",
      searchEnabled: true,
      allowSelectAll: true,
      selectByClick: true,
      recursive: true,
      editorOptions: { placeholder: "Search column" },
      loadingVisible: false,
      position: { of: "#load" },
      showIndicator: true,
      shading: true,
      showPane: true,
      hideOnOutsideClick: false,

      gridShowHonor: false,
      gridShowKontrak: false,
      gridShowTetap: false,
      columnsHonor: null,

      pegawaiSource: new ODataStore({
        url: `${ODATA_BASE_URL}/SimpegPegawais`,
        key: "id",
      }),
      numberingPageSize: 50,
      numberingPageNumber: 0,
      // dataSource: [
      //   {
      //     ID: 0,
      //     pegawai_id: "",
      //   },
      // ],
      dataSource: [],
      filters: {
        bulan: Number(currentMonth),
        tahun: currentYear,
        pegawai_status_id: "",
        gaji_skema_id: "",
      },
      bulanSource: months,
      tahunSource: years,
      stylingMode: "outlined",
      //outlined, filled, underlined
      labelMode: "floating",

      pegawaiStatusSource: null,
      cabangSource: null,
      unitSource: null,
      bagianSource: null,
      bidangSource: null,
      subBagianSource: null,
      golonganSource: null,
      subBidangSource: null,
      seksiSource: null,
      jabatanSource: null,
      skemaGajiSource: null,
      editedSource: [
        { val: true, nama: "Diedit user" },
        { val: false, nama: "Dibuat sistem" },
      ],
    };
  },
  computed: {
    gridHeight() {
      // Calculate grid height based on your requirements
      return "80vh"; // Set the height to fill the viewport vertically
    },
    columnsBase() {
      return [
        {
          dataField: "created_at",
          caption: "No.",
          cellTemplate: "numberingTemplate",
          allowFiltering: false,
          allowSorting: false,
        },
        {
          dataField: "pegawai.nik",
          caption: "NIK",
        },
        {
          dataField: "pegawai.nama",
          caption: "Nama",
        },
        {
          dataField: "riwayatGolongan.golongan_id",
          caption: "Gol.",
          lookup: {
            dataSource: this.golonganSource,
            valueExpr: "id",
            displayExpr: "nama",
          },
        },
      ];
    },
  },
  async mounted() {
    // this.columnsHonor = await this.getDatagridColumns(3);
    // this.columnsKontrak = await this.getDatagridColumns(4);
    this.columnsHonor = _.concat(
      _.cloneDeep(this.columnsBase),
      await this.getDatagridColumns(3)
    );

    this.columnsTetap = _.concat(
      _.cloneDeep(this.columnsBase),
      await this.getDatagridColumns(2)
    );

    this.golonganSource = await this.golonganStore.get();
    this.jabatanSource = await this.jabatanStore.get();
    this.bagianSource = await this.bagianStore.get();
    this.bidangSource = await this.bidangStore.get();
    this.subBagianSource = await this.subBagianStore.get();
    this.subBidangSource = await this.subBidangStore.get();
    this.seksiSource = await this.seksiStore.get();
    this.cabangSource = await this.cabangStore.get();
    this.unitSource = await this.unitStore.get();

    this.pegawaiStatusSource = await this.pegawaiStatusStore.get();
  },

  methods: {
    refreshDatagrid(gridRef) {
      this.$refs[gridRef].instance.getDataSource().reload();
    },
    detailPegawai(e) {
      const url = this.$router.resolve({
        name: "simpeg-pegawai-detail",
        query: { id: e.row.data.pegawai_id },
      }).href;
      window.open(url, "_blank");

      // this.$router.push({
      //   name: "simpeg-pegawai-detail",
      //   query: { id: e.row.data.pegawai_id },
      // });
    },
    async onRowUpdating(e, ref) {
      e.cancel = true;
      var re = await this.saveEditedDataToOData(e.key, e.newData, e.oldData);
      if (re.status) {
        e.component.cancelEditData();
        // var instance = this.$refs[ref].instance;
        this.$refs[ref].instance.cancelEditData();

        //update column
        var rowIndex = e.component.getRowIndexByKey(e.key);

        for (const columnName in e.newData) {
          const columnValue = e.newData[columnName];
          e.component.cellValue(rowIndex, columnName, columnValue);
          // instance.cellValue(rowIndex, columnName, columnValue);
        }
        // var visibleCols = e.component.getVisibleColumns();
        // for (const col in visibleCols) {
        //   const dataField = visibleCols[col].dataField;
        // }

        for (const col in re.data) {
          const val = re.data[col];
          e.component.cellValue(rowIndex, col, val);
          // instance.cellValue(rowIndex, col, val);
        }
        e.component.refresh();

        // e.component.saveEditData();
      }
    },

    async saveEditedDataToOData(key, newData, oldData) {
      try {
        const config = {
          headers: {
            Authorization: api.defaults.headers.common["Authorization"],
            "content-type": "application/json",
          },
        };
        var data = {
          id: key,
          pegawai_id: oldData.pegawai_id,
          tgl_gaji: oldData.tgl_gaji,
          absen_bulan_id: oldData.absen_bulan_id,
          changes: newData,
        };
        const response = await axios.post(
          `${API_BASE_URL}/refresh_gaji_per_pegawai`,
          data,
          config
        );
        // You can access the response data using response.data
        if (response.data.status) {
          notify(response.data.message, "success");
          return response.data;
        } else {
          notify("Gagal update gaji pegawai", "error");
          return response.data;
        }
        // You can perform other operations here based on the response data
        // ...
      } catch (error) {
        // Handle the error appropriately
        console.error("Error:", error);
        notify("Gagal update gaji pegawai " + error, "error");
        return false; // If there was an error
      }
    },

    approveAllDialog() {
      let result = confirm("<i>Approve semua gaji?</i>", "Konfirmasi");
      result.then((dialogResult) => {
        if (dialogResult) {
          this.approveAll();
        }
      });
    },
    async approveAll() {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      var data = {};
      data = {
        pegawai_status_id: this.filters.pegawai_status_id,
        pegawai_status_nama: "",
      };
      await axios
        .post(`${API_BASE_URL}/gaji_approve_all`, data, config)
        .then((response) => {
          notify(response.data.message, "success");
          this.dataSource.reload();
        })
        .catch((error) => {
          console.log(error);
          notify("Gagal approve gaji", "error");
        });
    },

    approveClick(e) {
      if (e.data.value) return 0;
      let result = confirm("<i>Approve gaji pegawai?</i>", "Konfirmasi");
      result.then((dialogResult) => {
        if (dialogResult) {
          if (this.approveGaji(e.data.data.id)) {
            e.data.data.status_gaji = true;
          }
        }
      });
    },
    async approveGaji(gajiId) {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "multipart/form-data",
        },
      };
      var data = {
        id: gajiId,
      };

      axios
        .post(`${API_BASE_URL}/gaji_approve`, data, config)
        .then((response) => {
          notify(response.data.message, "success");
          return true;
        })
        .catch((error) => {
          notify("Gagal approve gaji", "error");
          console.log(error);
          return false;
        });
    },
    formatStatusGaji(method, value) {
      if (value.data.data.status_gaji) {
        if (method == "icon") return "lock";
        if (method == "type") return "success";
        // this.statusButtonIcon = "lock";
        // this.statusButtonType = "success";
        // return "Approved";
      } else {
        if (method == "icon") return "edit";
        if (method == "type") return "danger";
      }

      // return "Draft";
      return;
    },
    oneditorpreparing: function (e) {
      if (e.parentType === "dataRow") {
        if (e.row.data.status_gaji) e.editorOptions.disabled = true;
        else {
          if (e.class == "noteditable") e.editorOptions.disabled = true;
        }
      }

      if (e.dataField === "tgl_gaji") {
        e.editorOptions.calendarOptions = {
          minZoomLevel: "year",
          maxZoomLevel: "year",
          displayFormat: "MM/yyyy",
          type: "month",
        };
      }
    },

    // showLoadPanel() {
    //   this.loadingVisible = true;
    // },
    // onShown() {
    //   setTimeout(() => {
    //     this.loadingVisible = false;
    //   }, 3000);
    // },
    // onHidden() {
    //   // this.employeeInfo = employee;
    // },

    formatNumber(value) {
      if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
      return value;
    },

    calculateCellMK(e) {
      //TODO nyari masa kerja bukan dari tgl sekarang, melainkan tgl pembuatan gaji
      const today = DateTime.fromISO(e.tgl_gaji);
      const tglMulaiKerja = DateTime.fromISO(e.pegawai.tgl_mulai_bekerja);

      const month = tglMulaiKerja.month + 1; // Months are zero-based, so add 1
      const year = tglMulaiKerja.year;

      var tglMk;
      if ((month >= 11 && month <= 12) || (month >= 1 && month <= 4)) {
        // If the month is between November and April (inclusive), set the date to April 1st
        tglMk = DateTime.fromObject({ year: year, month: 4, day: 1 });
      } else if (month >= 3 && month <= 10) {
        // If the month is between March and October (inclusive), set the date to October 1st
        tglMk = DateTime.fromObject({ year: year, month: 10, day: 1 });
      } else {
        // Handle other cases as needed
        tglMk = tglMulaiKerja;
      }
      return Math.floor(today.diff(tglMk, "years").years);
    },

    async getDatagridColumns(pegawaiStatusId) {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      var data = {
        pegawai_status_id: pegawaiStatusId,
      };
      const response = await axios.post(
        `${API_BASE_URL}/return_gaji_columns_final`,
        data,
        config
      );
      return response.data;
    },

    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Gaji");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Gaji Pegawai " +
              this.filters.pegawai_status_id +
              " Periode Bulan " +
              this.filters.bulan +
              " " +
              this.filters.tahun +
              ".xlsx"
          );
        });
      });
      e.cancel = true;
    },

    onDataGridLoad() {
      const datagrid = this.$refs.gridRef.instance;
      datagrid.endCustomLoading();
    },
    onPageChanged(e, gridRef) {
      if (e.fullName == "paging.pageIndex") {
        this.numberingPageSize = this.$refs[gridRef].instance.pageSize();
        this.numberingPageNumber = e.value;
      }
    },

    async validateFilter(e) {
      const result = e.validationGroup.validate();

      if (!result.isValid) return 0;
      // this.generateGaji();
      // return 0;
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      // let dataFin = JSON.stringify(data);
      var data = {
        bulan: this.filters.bulan,
        tahun: this.filters.tahun,
        gaji_skema_id: this.filters.gaji_skema_id,
        pegawai_status_id: this.filters.pegawai_status_id,
      };

      await axios
        .post(`${API_BASE_URL}/generate_gaji_check`, data, config)
        .then((response) => {
          if (response.data.status) {
            notify("Penggajian mulai diproses", "success");

            this.generateGaji();
          } else {
            notify(response.data.message, "error");
          }
        })
        .catch((error) => {
          console.log(error);
          notify("gagal generate gaji", "error");
        });
    },

    async generateGaji() {
      //reset datagrid col, biar ga nge add!
      this.loadingVisible = true;
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      // let dataFin = JSON.stringify(data);
      var data = {
        bulan: this.filters.bulan,
        tahun: this.filters.tahun,
        gaji_skema_id: this.filters.gaji_skema_id,
        pegawai_status_id: this.filters.pegawai_status_id,
        proyeksi: false,
      };

      // var url = "generate_gaji";
      var url = "generate_gaji_kgb_kp";
      // if (this.filters.pegawai_status_id == 1) {
      //   //GAJIDIREKSI
      //   url = "generate_gaji_direksi";
      // }
      await axios
        // .post("http://127.0.0.1/api/return_gaji", data, config)
        //WARNING TODO NANTI UBAH URL
        .post(`${API_BASE_URL}/` + url, data, config)
        // .post("http://127.0.0.1/api/gaji_final_kontrak_honor", data, config)
        .then((response) => {
          notify(response.data.message, "success");
          // const datagrid = this.$refs.gridRef.instance;
          // datagrid.state({});
          // datagrid.beginCustomLoading("Loading...");

          // this.addColumn(response.data.columns);

          // reactivity system will update HTML automatically
        })
        .catch((error) => {
          console.log(error);
          notify("gagal generate gaji", "error");
        });
    },

    async getGaji() {
      var filterUrl = ["gaji_skema_id", this.filters.gaji_skema_id];
      if (this.filters.pegawai_status_id == 4) {
        this.gridShowHonor = true;
        this.gridShowKontrak = false;
        this.gridShowTetap = false;
      } else if (this.filters.pegawai_status_id == 5) {
        this.gridShowHonor = false;
        this.gridShowKontrak = true;
        this.gridShowTetap = false;
      } else if (
        this.filters.pegawai_status_id == 2 ||
        this.filters.pegawai_status_id == 3
      ) {
        this.gridShowHonor = false;
        this.gridShowKontrak = false;
        this.gridShowTetap = true;
      } else if (this.filters.pegawai_status_id == 1) {
        this.gridShowHonor = false;
        this.gridShowKontrak = false;
        this.gridShowTetap = true;
        filterUrl = [
          ["gaji_skema_id", 1],
          "or",
          ["gaji_skema_id", 2],
          "or",
          ["gaji_skema_id", 3],
        ];
      }

      this.dataSource = new DataSource({
        store: new ODataStore({
          // ODataStore is configured here
          url: `${ODATA_BASE_URL}/PegawaiGajiFinals`,
          key: "id",
          version: 4,
          beforeSend: function (e) {
            e.headers = {
              "odata-version": "4.0",
            };
            if (e.method == "PATCH") {
              e.payload.edited_by_user = true;
            }

            if (hasFilterNestedTable(e.params.$filter)) {
              e.params.$filter = convertFilter(
                e.params.$filter,
                "riwayatGolongan"
              );
              e.params.$filter = convertFilter(
                e.params.$filter,
                "riwayatPekerjaan"
              );
              e.params.$filter = convertFilter(e.params.$filter, "riwayatPlt");
              e.params.$filter = convertFilterPegawai(e.params.$filter);
            }
          },
        }),

        // expand: [
        //   "simpegPegawai,pegawaiGajiDetails,pegawaiGajiDetails($expand=gajiSkemaKomponen),pegawaiGajiDetails($expand=gajiSkemaKomponen($expand=gajiItem))",
        // ],
        expand: [
          "riwayatPekerjaan,riwayatGolongan,pegawai,absenBulan,riwayatPlt",
        ],
        filter: [
          ["proyeksi", false],
          "and",
          filterUrl,
          "and",
          ["tgl_gaji", this.filters.tahun + "-" + this.filters.bulan + "-01"],
        ],
        // [["gaji_skema_id", 2], "and", ["tgl_gaji", "2023-10-01"]],
      });

      this.loadingVisible = false;
    },
    async onPegawaiChanged(e) {
      this.filters.gaji_skema_id = "";

      var skemaId = parseInt(e.value);

      // var data = {
      //   pegawai_status_id: skemaId,
      // };
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      var res = await axios.get(`${API_BASE_URL}/gajiSkema/${skemaId}`, config);
      this.skemaGajiSource = res.data;
    },
  },
};

function hasFilterNestedTable(str) {
  return (
    _.includes(str, "/") ||
    _.includes(str, "[") ||
    _.includes(str, "]") ||
    _.includes(str, "riwayatPekerjaan/") ||
    _.includes(str, "riwayatGolongan/") ||
    _.includes(str, "pegawai/")
  );
}

function convertFilterPegawai(filter) {
  var searchTerm = (filter.match(
    /contains\(tolower\(pegawai\/nama\),'([^']+)'/
  ) || [])[1];
  var replacedString = filter.replace(
    /contains\(tolower\(pegawai\/nama\),'([^']+)'/,
    `pegawai/any(s:(contains(tolower(s/nama),'${searchTerm}'))`
  );

  var searchTermNik = (replacedString.match(
    /contains\(tolower\(pegawai\/nik\),'([^']+)'/
  ) || [])[1];
  var replacedStringNik = replacedString;

  replacedStringNik = replacedString.replace(
    /contains\(tolower\(pegawai\/nik\),'([^']+)'/,
    `pegawai/any(s:(contains(tolower(s/nik),'${searchTermNik}'))`
  );

  return replacedStringNik;
}

function convertFilter(filter, regVar) {
  // const regex = new RegExp(`${regVar}\/(\\w+) eq (\\d+)`, "g"); //utk detect riwayatPekerjaan/cabang_id eq 2
  const regex = new RegExp(`${regVar}/(\\w+) eq (\\d+)`, "g");
  const outputString = filter.replace(regex, (match, p1, p2) => {
    return `${regVar}/any(s:s/${p1} eq ${p2})`;
  });
  return outputString;
}
</script>
